import React from 'react';
import { Phone } from 'lucide-react';
export function StickyNav() {
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="flex justify-between items-center h-20" data-id="element-130">
          <div className="flex-shrink-0 flex items-center" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/nw66UfUb5KWH6rNxhPmKiS/KEENA-logo-web.png" alt="Keena PEO" className="h-10" data-id="element-132" />
          </div>
          <div className="flex items-center space-x-4" data-id="element-133">
            <a href="tel:5187939825" className="hidden sm:flex items-center text-navy font-semibold hover:text-orange transition-colors" data-id="element-134">
              <Phone className="w-4 h-4 mr-2" data-id="element-135" />
              (518) 793-9825
            </a>
            <a href="#form-bottom" className="bg-navy hover:bg-navy-light text-white font-medium py-2 px-5 rounded-lg transition-colors duration-200" data-id="element-136">
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </header>;
}